import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete-new",
  "use": "icon-delete-new-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-delete-new\"><path d=\"M304.529 241.562L785.745 722.78c13.484 13.483 13.484 40.45-4.452 58.514a43.504 43.504 0 01-62.967 0L241.5 304.465a43.504 43.504 0 010-62.966 43.504 43.504 0 0162.966 0z\" /><path d=\"M781.23 304.529L300.012 785.745c-13.484 13.484-40.451 13.484-58.514-4.452a43.504 43.504 0 010-62.967l476.764-476.764a43.504 43.504 0 0162.966 0 43.504 43.504 0 010 62.967z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol